import errorMessages from "./errorMessages";

/**
 * Full-list validations that need sibling/original context a single
 * criterion's Yup schema doesn't have. Both host apps (admin scenario
 * creator, client recruitment form) must call these across their own
 * criterion lists so the two never drift into different validation logic.
 *
 * @param {Array<{criterionKey: string}>} criteria
 * @returns {string|null} business-language error, or null if valid
 */
export function validateNoDuplicateKeys(criteria) {
    const seen = new Set();
    for (const c of criteria ?? []) {
        if (!c.criterionKey) continue;
        if (seen.has(c.criterionKey)) return errorMessages.duplicateCriterionKey;
        seen.add(c.criterionKey);
    }
    return null;
}

/**
 * @param {Array<{criterionKey: string, scoring?: object}>} criteria - the criteria being saved
 * @param {Array<{criterionKey: string, scoring?: object, overrideMode?: string}>} originalScenarioCriteria - the scenario's own criteria, as last fetched
 * @returns {string|null}
 */
export function validateNoLockedEdits(criteria, originalScenarioCriteria) {
    const lockedByKey = new Map(
        (originalScenarioCriteria ?? [])
            .filter((c) => c.overrideMode === "LOCKED")
            .map((c) => [c.criterionKey, c.scoring])
    );
    for (const c of criteria ?? []) {
        const originalScoring = lockedByKey.get(c.criterionKey);
        if (!originalScoring) continue;
        if (JSON.stringify(c.scoring) !== JSON.stringify(originalScoring)) {
            return errorMessages.lockedCriterionEdit;
        }
    }
    return null;
}
